import { ChangeEvent, useCallback, useEffect, useState } from 'react';

import { useDebounce } from '@mint-lib/hooks';
import { useTranslation } from '@mint-lib/i18n';

import { Box, SearchBar, Typography } from '@myn/mui';

type Props = { onSearch?: (value: string) => void };

const Header: React.FC<Props> = ({ onSearch }) => {
  const { t } = useTranslation('@myn/planning');

  const [value, setValue] = useState<string>('');

  const debouncedValue = useDebounce(value, 500);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  }, []);

  useEffect(() => {
    onSearch?.(debouncedValue);
  }, [debouncedValue, onSearch]);

  return (
    <Box sx={{ mb: '16px' }}>
      <Typography variant="h4" sx={{ mb: '16px' }}>
        {t('Available columns group')}
      </Typography>
      <SearchBar
        size="small"
        aria-label="Search columns"
        placeholder={t('Search columns')}
        value={value}
        onChange={handleChange}
        onClear={() => setValue('')}
      />
    </Box>
  );
};

export default Header;
